import React from 'react';
import ComponentBox from 'components/BusinessLogic/Components/ComponentBox';
import { faBuilding, faCar, faInfo } from '@fortawesome/free-solid-svg-icons';
import currencyFormat from 'utils/currency-format';
import Exchange from 'components/UI/Exchange';
import Guests from 'components/UI/Guests';
import PropTypes from 'prop-types';
import ComponentSummary from 'components/BusinessLogic/Components/ComponentSummary';
import Button from 'components/UI/Button';
import PopUp from 'components/UI/PopUp';
import Row from 'components/UI/Layout/Row';

function Service({
    service, dateLabel, showCommission, requestQuoteComponentId, requestQuoteId, handleEditService,
})
{
    const { vendorService } = service;
    const description = `${vendorService ? `${vendorService.vendor.name}: ${vendorService.name}` : ''} ${service.informative_name ?? ''}`;

    const parseNames = (name) => name.replace('_', ' ');

    return (
        <ComponentBox
            typeName={`${service?.informative_type === 'Hotel' ? 'Hotel' : 'Service'} ${service.service_time ? ` - ${service.service_time}` : ''}`}
            description={description}
            date={dateLabel}
            icon={service?.informative_type === 'Hotel' ? faBuilding : faCar}
            requestQuoteComponentId={requestQuoteComponentId}
            requestQuoteId={requestQuoteId}
            summaryContent={(
                <ComponentSummary
                    showCommission={showCommission}
                    className="tw-mt-4"
                    currency={service.currency}
                    total={service.total_price}
                    commission={parseFloat(service.commission_tracking_travel_agent_commissionable_amount) + parseFloat(service.direct_travel_agent_commission_amount)}
                />
            )}
        >
            <div className="tw-px-3 tw-w-full tw-rounded-t-md tw-py-1 tw-mt-1 " style={{ height: 180 }}>
                <div className="tw-flex tw-flex-row tw-flex-wrap">
                    <span className="tw-w-1/2"><b>Booking Type:</b> {service?.type}</span>
                    <span className="tw-w-1/2"><b>Tax:</b> {currencyFormat(service.tax, 2, '')}%</span>

                    <span className="tw-w-1/2"><b>Type:</b> {vendorService?.type ?? service?.informative_type}</span>
                    <span className="tw-w-1/2"><b>Guests: </b>
                        <Guests
                            childrenAndAges={service.number_of_children_and_ages}
                            adults={service.number_of_adults}
                            infantsAndAges={service.number_of_infants_and_ages}
                        />
                    </span>

                    {showCommission
                        && <span className="tw-w-1/2"><b>Commission: </b>{currencyFormat(service.commission_tracking_travel_agent_commissionable_amount)} </span>}
                    <span className="tw-w-full"><b>T. Price:</b> <Exchange price={service.total_price} currency={service.currency} /></span>

                    {service?.columns && service.columns.length > 0 && (
                        <>
                            <PopUp
                                textButton="Additional Information"
                                icon={faInfo}
                            >
                                { service.columns.map((serviceColumn) => (
                                    <>
                                        <span key={serviceColumn.name} className="tw-w-1/2 tw-capitalize"><b>{parseNames(serviceColumn.name)}:</b> {serviceColumn?.value ?? ''}</span>
                                        <br />
                                    </>
                                ))}
                            </PopUp>
                            <br />
                        </>
                    )}

                    {handleEditService && service.type === 'Informative' && (
                        <Row>
                            <Button onClick={() => handleEditService(service?.informative_type)}>Edit {service?.informative_type === 'Hotel' ? 'Hotel' : 'Service'} Information</Button>
                        </Row>
                    )}
                </div>
            </div>
        </ComponentBox>
    );
}

Service.defaultProps = {
    dateLabel: null,
    showCommission: true,
    service: {
        direct_travel_agent_commission_amount: '',
        commission_tracking_travel_agent_commissionable_amount: '',
        service_date: '',
        service_time: '',
        type: '',
        informative_type: '',
        informative_name: '',
        tax: null,
        total_price: null,
        number_of_children_and_ages: [],
        number_of_infants_and_ages: [],
        number_of_adults: null,
        vendorService: {
            name: '',
            type: '',
            vendor: {
                name: '',
            },
        },
    },
};

Service.propTypes = {
    requestQuoteId: PropTypes.number,
    requestQuoteComponentId: PropTypes.number,
    showCommission: PropTypes.bool,
    handleEditService: PropTypes.func,
    dateLabel: PropTypes.string,
    service: PropTypes.shape({
        commission_tracking_travel_agent_commissionable_amount: PropTypes.any,
        direct_travel_agent_commission_amount: PropTypes.any,
        service_date: PropTypes.string,
        service_time: PropTypes.string,
        type: PropTypes.string,
        tax: PropTypes.any,
        total_price: PropTypes.any,
        informative_type: PropTypes.string,
        informative_name: PropTypes.string,
        number_of_children_and_ages: PropTypes.array,
        number_of_infants_and_ages: PropTypes.array,
        columns: PropTypes.array,
        number_of_adults: PropTypes.number,
        currency: PropTypes.shape({
            currency_change: PropTypes.number,
            code: PropTypes.string,
        }),
        vendorService: PropTypes.shape({
            name: PropTypes.string,
            type: PropTypes.string,
            vendor: PropTypes.shape({
                name: PropTypes.string,
            }),
        }),
    }),
};

export default Service;
